import type VueRouter from 'vue-router'
import type { Route, Location, RawLocation } from 'vue-router'
import { useState } from './store'
import { IUserStoreState } from '@/store/modules/user'

type Dictionary<T> = { [key: string]: T }
type _Location =
  | Location
  | {
    params?: Dictionary<any>
  }
interface _VueRouter extends VueRouter {
  push(location: string | _Location): Promise<Route>
  push(
    location: string | _Location,
    onComplete?: any,
    onAbort?: any
  ): void
}

let router: _VueRouter | null = null

export function registerRouter(appRouter: any) {
  router = appRouter
  window.$router = appRouter
}

export function useRouter() {
  return router
}

export function useQuery<T = any>() {
  return router?.currentRoute.query as any as T
}

export function useRoute<T = any>() {
  return {
    query: router?.currentRoute?.query as any as T,
    params: router?.currentRoute?.params as any as T,
  }
}

// 在跳转时保留query参数
export const preserveQuery = (to: Location) => {
  const currentQuery = router?.currentRoute.query;
  return { ...to, query: { ...to.query, ...currentQuery } };
};